import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;
const VOUCHER_SP_ENDPOINT = `${REACT_APP_REST_ENDPOINT}/voucher-superpartner`;

// Struttura a oggetto, coerente con gli altri tuoi servizi
const VoucherSuperpartnerService = {

    updateQuantity(data) {
        const url = `${VOUCHER_SP_ENDPOINT}/update-quantity`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    getStock(data) {
        const url = `${VOUCHER_SP_ENDPOINT}/get-magazzino`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    },

    getHistory(data) {
        const url = `${VOUCHER_SP_ENDPOINT}/history`;
        return new Promise((resolve, reject) => {
            ApiService.postRequest(resolve, reject, url, data);
        });
    }
};

export default VoucherSuperpartnerService;